// extracted by mini-css-extract-plugin
export var deliveryRow = "_sw-a";
export var fixedHeight = "_sw-4";
export var freightLogo = "_sw-9";
export var fullWidth = "_sw-3";
export var priceColumn = "_sw-5";
export var radioSelected = "_sw-7";
export var radioUnselected = "_sw-6";
export var selectedOption = "_sw-2";
export var selectedOptionContainer = "_sw-1";
export var selection = "_sw-0";
export var tallSkeletonText = "_sw-8";